import { createSelector } from '@ngrx/store';
import { selectAnalyticsState } from './analytics.selectors';

export const selectAnalyticsOrderHistoryResponse = createSelector(
    selectAnalyticsState,
    (state) => state.ordersHistoryResponse,
);
